// src/components/Contact.js
import React from "react";

function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="section-inner">

        <div className="contact-grid">

          {/* Left: Info */}
          <div className="contact-info">
            <div className="section-tag">
              <i className="fas fa-envelope"></i> Contact Us
            </div>
            <h2>Let's Build Something Great Together</h2>
            <p>
              Whether you need a powerful data pipeline, a stunning website, or a digital marketing
              strategy — we're here to help. Reach out and let's discuss your project.
            </p>

            <div className="contact-detail">
              <div className="contact-detail-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <h4>Email Us</h4>
                <p>infomechfolkstechnologies@gmail.com</p>
              </div>
            </div>

            <div className="contact-detail">
              <div className="contact-detail-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <h4>Call / WhatsApp</h4>
                <p>+91 99405 46432</p>
              </div>
            </div>

            <div className="contact-detail">
              <div className="contact-detail-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Location</h4>
                <p>Bangalore, Karnataka, India</p>
              </div>
            </div>

            <div className="contact-detail">
              <div className="contact-detail-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div>
                <h4>Working Hours</h4>
                <p>Mon – Sat: 9:00 AM – 7:00 PM IST</p>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="contact-form-card">
            <h3>Send Us a Message</h3>
            <p>We typically respond within 24 hours. Fill out the form below!</p>

            <form
              name="contact"
              method="POST"
              action="/thankyou"
              data-netlify="true"
              className="contact-form"
            >
              <input type="hidden" name="form-name" value="contact" />

              <div className="form-row">
                <div className="form-group">
                  <label>Your Name *</label>
                  <input type="text" name="name" placeholder="John Doe" required />
                </div>
                <div className="form-group">
                  <label>Email Address *</label>
                  <input type="email" name="email" placeholder="john@company.com" required />
                </div>
              </div>

              <div className="form-group">
                <label>Service You're Interested In</label>
                <select name="subject">
                  <option value="">Select a service...</option>
                  <option value="Data Engineering">Data Engineering</option>
                  <option value="Website Development">Website Development</option>
                  <option value="Digital Marketing">Digital Marketing</option>
                  <option value="Mobile Application">Mobile Application</option>
                  <option value="E-commerce">E-commerce Platform</option>
                  <option value="Analytics & Dashboards">Analytics &amp; Dashboards</option>
                  <option value="SEO & Content">SEO &amp; Content Marketing</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Your Message *</label>
                <textarea
                  name="message"
                  placeholder="Tell us about your project, goals, and timeline..."
                  rows="5"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn-primary">
                Send Message &nbsp;→
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Contact;
